<template>
    <div v-esddrop="{ fn: $root.handleDropFromComponent, args: { name } }" class="CenteredContainer">
        <!-- <div class="CenteredContainer" v-esddrop="{ fn: dropObj.fn, args: { name: dropObj.name } }"> -->
        <h3>{{ name }}</h3>
        <div class="CardDropArea InfoBoard">
            <table id="json-object" class="table table-hover InfoBoardEx InfoBoard" width="100%">
                <thead v-if="tableheadings" class="thead-dark">
                    <tr>
                        <th class="key">Key</th>
                        <th class="value">Value</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(v, k, i) in rowsMap">
                        <tr v-if="isVisible(k, v)" :key="i">
                            <td class="key">
                                <span class="key eye" :class="{ kc_icons: mappingForKey(k, 'type') == 'password' }" @click="togglePassword"></span>
                                {{ k.startsWith('_') ? k.substring(1) : k }}
                            </td>
                            <td>
                                <input
                                    v-if="mappingForKey(k, 'nodetype', 'input') === 'input'"
                                    ref="passwordfield"
                                    v-model="currentValues[k]"
                                    :placeholder="rows[k]"
                                    :data-type="mappingForKey(k, 'type')"
                                    :type="mappingForKey(k, 'type')"
                                    :disabled="isDisabled(k)"
                                    @input="onInput(k, $event.target.value)"
                                />
                                <textarea
                                    v-else
                                    :value="textareaDisplayValue(k)"
                                    :placeholder="rows[k]"
                                    rows="4"
                                    cols="50"
                                    type="textarea"
                                    @input="onInput(k, $event.target.value)"
                                ></textarea>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div class="stats">
                <!-- <template v-for="(v, k, i) in stats">
                    <div :key="i">{{ v }}:{{ rows[v] }}</div>
                </template> -->
            </div>
        </div>
    </div>
</template>

<script>

// function renameKeys(obj, newKeys) {
//     const keyValues = Object.keys(obj).map((key) => {
//         const newKey = newKeys[key] || key;
//         return { [newKey]: obj[key] };
//     });
//     return Object.assign({}, ...keyValues);
// }

function renameObjectKeys(sourceObj, mapObj) {
    if (!mapObj) return sourceObj;
    const keyValues = Object.keys(sourceObj).map((key) => ({ [mapObj[key] || key]: sourceObj[key] }));
    // const keyValues = Object.keys(sourceObj).map((key) => {
    //     const o = mapObj[key] || key;
    //     // if (typeof o === 'object' && o.name) return { [o.name]: sourceObj[key] }; // passed in types: {Name: {name: 'Hello'}}
    //     if (typeof o === 'object') {
    //         if (o.name) return { [o.name]: sourceObj[key] }; // passed in types: {Name: {name: 'Hello'}}
    //         return { [key]: sourceObj[key] };
    //     }
    //     return { [mapObj[key] || key]: sourceObj[key] };
    // });
    return Object.assign({}, ...keyValues);
}

export default {
    name: 'JsonComponent',
    props: {
        name: {
            type: String,
            default: ''
        },
        rows: {
            type: Object,
            default() {
                return {};
            }
        },
        tableheadings: Boolean,
        excludes: {
            type: Array,
            default() {return []},
        },
        namesmap: {
            type: Object,
            default() {return {}},
        },
        typesmap: {
            type: Object,
            default() {return {}},
        },
    },
    data() {
        return {
            currentValues: {},
        };
    },
    computed: {
        rowsMap() {
            return renameObjectKeys(this.rows, this.namesmap);
        },
        stats() {
            const stat = [];
            for (let k in this.rows) {
                if (this.excludes.includes(k.charAt(0))) {
                    stat.push(k);
                }
            }
            return stat;
        },
    },
    methods: {
        // logme(rows, k, v) {
        //     console.log('logme', rows, k, rows[k], v);
        // },
        togglePassword() {
            this.$refs.passwordfield.forEach((f) => {
                if (f.getAttribute('data-type') == 'password') {
                    f.type = f.type == 'password' ? 'text' : 'password';
                }
            });
        },
        textareaDisplayValue(k) {
            if (this.currentValues[k] !== undefined && this.currentValues[k] !== null) {
                return this.currentValues[k];
            }
            const fromRows = this.rows[k];
            return fromRows === undefined || fromRows === null ? '' : String(fromRows);
        },
        onInput(key, value) {
            this.$set(this.currentValues, key, value);
            this.$emit('input', { ...this.rows, ...this.currentValues });
        },
        mappingForKey(k, prop, defaultValue = 'text') {
            const t = this.typesmap[k];
            return t && t[prop] ? t[prop] : defaultValue;
        },
        isDisabled(k) {
            return k.startsWith('_');
        },
        isVisible(k, v) {
            if (k == '_Icon') return true;
            const t = typeof v;
            if (k == 'License' || ['function', 'object'].includes(t)) return false;
            return this.excludes.some((e) => !k.startsWith(e));
        },
    },
};
</script>

<style scoped>
.yycontainer {
    padding: 16px;
    overflow-x: scroll;
    width: 96%;
    margin-top: 20px;
    margin-bottom: 20px;
}
td {
    white-space: nowrap;
    min-width: 80px;
}

th {
    text-transform: uppercase;
}

th.key,
td.key {
    text-align: right;
    padding-right: 8px;
}

th.value {
    text-align: left;
    padding-left: 10px;
}

td.key::after {
    content: ' : ';
}

.fileName {
    min-width: 280px;
    max-width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
/* td input {
    width: 96%;
} */
</style>
